<template>
  <div class="main-body">
    <LayoutPc />
  </div>
</template>

<script>
  import LayoutPc from '../layouts/layout-pc'

  export default {
    name: "home",
    components: {
      LayoutPc
    },
    methods:{},
    mounted () {},
    created () {}
  }
</script>

<style scoped>
.main-body{
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/main.vue